const gaConfigObject = {
  mobileWidth: 1000,
  softHiddenClass: "soft-hidden",
};

// to aviod the global namescape conflicts
(() => {
  // HEADER
  const hideClass = "ihidden";
  const softHiddenClass = "soft-hidden";
  const topbarBgColorCssVarName = "--ga-topbar-bg-color";
  const topbarHeightCssVarName = "--ga-topbar-height";
  const currencySwitcherSelector = ".bacurr-cur-blocker";
  const mobileWidth = 998;

  // header
  const topbarCloseBtn = document.querySelector("#js-topbar-close-btn");
  const topbarCr = document.querySelector(".js-ga-topbar-cr");
  const headerElem = document.querySelector(".js-ga-header-2024");
  const searchBtns = document.querySelectorAll(".js-search-btn");
  const cartBtn = document.querySelector(".js-cart-btn");
  const menuBtn = document.querySelector(".js-h2024-menu-button");
  const megaMenu = document.querySelector(".js-ga-megamenu-2024-wr");
  const mobileMegaMenu = document.querySelector(
    ".js-ga-megamenu-2024-wr--mobile"
  );
  const closeMegaMenuBtns = document.querySelectorAll(".js-gamm2024-close-btn");
  const mobileMenuLis = document.querySelectorAll(
    ".js-mgamm2024-menu-ul .mgamm2024-menu-li.has-submenu"
  );
  const mobileBackToMenuBtn = document.querySelector(
    ".js-mobile-back-to-menu-btn"
  );

  // header
  topbarCloseBtn?.addEventListener("click", handleTopbarCloseBtn);
  const topbarObserver = new IntersectionObserver(topbarObserverCallbk, {
    threshold: 0,
  });
  if (topbarCr) topbarObserver.observe(topbarCr);
  searchBtns.forEach((searchBtn) =>
    searchBtn.addEventListener("click", handleSearchBtnClick)
  );
  cartBtn?.addEventListener("click", handleCartBtnClick);
  menuBtn?.addEventListener("click", handleMenuBtn);
  closeMegaMenuBtns.forEach((closeBtn) =>
    closeBtn.addEventListener("click", handleMenuBtn)
  );
  mobileMenuLis.forEach((li) =>
    li.addEventListener("click", handleMobileMenuLiClick)
  );
  mobileBackToMenuBtn?.addEventListener("click", handleMobileBackToMenuBtn);

  function handleTopbarCloseBtn() {
    const currencySwicther = document.querySelector(currencySwitcherSelector);

    // hide topbar and currency switcher
    topbarCr.classList.add(hideClass);
    if (currencySwicther)
      // currencySwicther.setAttribute("style", "display: none !important;");
    document.body.style.marginTop = "0px";
    // update styles
    updateCSSVariable(topbarHeightCssVarName, "0px");
    updateCSSVariable(topbarBgColorCssVarName, "transparent");
  }

  function topbarObserverCallbk(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        headerElem.classList.add("ga-sticky-header");
      } else {
        headerElem.classList.remove("ga-sticky-header");
      }
    });
  }

  function handleSearchBtnClick() {
    window.spratlyTheme.Search.toggleSearchPopup(true);
  }

  function handleCartBtnClick() {
    window.spratlyTheme.Cart.openCartDrawer();
  }

  function handleMenuBtn() {
    const attrName = "data-menu-opened";
    const deviceWidth =
      window.innerWidth > 0 ? window.innerWidth : screen.width;

    if (!headerElem.hasAttribute(attrName)) {
      headerElem.setAttribute(attrName, "true");
      (deviceWidth > mobileWidth ? megaMenu : mobileMegaMenu).classList.remove(
        softHiddenClass
      );
    } else {
      headerElem.removeAttribute(attrName);
      (deviceWidth > mobileWidth ? megaMenu : mobileMegaMenu).classList.add(
        softHiddenClass
      );
    }
  }

  function handleMobileMenuLiClick() {
    mobileMegaMenu.setAttribute("data-submenu-opened", "true");
    mobileMenuLis.forEach((li) => li.removeAttribute("data-menu-selected"));
    this.setAttribute("data-menu-selected", "true");
  }

  function handleMobileBackToMenuBtn() {
    mobileMegaMenu.removeAttribute("data-submenu-opened");
    mobileMenuLis.forEach((li) => li.removeAttribute("data-menu-selected"));
  }
})();

(() => {
  // SLIDES
  $(".ga-main-slideshow").slick({
    slidesToShow: 1,
    arrows: false,
    nav: false,
  });
  $(".js-ga-fp-slider").slick({
    slidesToShow: 1.5,
    dots: true,
    arrows: true,
    nav: false,
    infinite: true,
     rtl: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
  });

  // slider 2
  const slider2 = document.querySelector(".js-ga-fp-slider-2");
  if (slider2 && isMobile()) slider2.removeAttribute("dir");

  $(slider2).slick({
    slidesToShow: 1.5,
    arrows: true,
    dots: true,
    nav: false,
    infinite: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    // rtl: !isMobile(),
    ltr: true,
  });
})();

(() => {
  // HOMEPAGE
  const slider2 = document.querySelector(".js-ga-fp-section-2");
  const popupCardOccasion = document.querySelector(".js-ga-popup-card-wr");
  const slider2Observer = new IntersectionObserver(s2Observer, {
    threshold: 0.1,
  });
  const card1CloseBtn = document.querySelector(".js-gapc-close-btn");

  const brandsSection = document.querySelector(".js-slider2-observer-target");
  const videoCard = document.querySelector(".js-ga-popup-card-wr-2");
  const brandObserver = new IntersectionObserver(bdObserver, {
    threshold: 0.1,
  });

  const scrollToBottomBtn = document.querySelector(".js-gams-scroll-down-link");

  card1CloseBtn?.addEventListener("click", () =>
    popupCardOccasion?.classList.add(gaConfigObject.softHiddenClass)
  );

  if (slider2) slider2Observer.observe(slider2);
  function s2Observer(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (popupCardOccasion)
          popupCardOccasion.classList.remove(gaConfigObject.softHiddenClass);
        observer.unobserve(entry.target);
      }
    });
  }

  if (brandsSection) brandObserver.observe(brandsSection);
  function bdObserver(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (videoCard)
          videoCard.classList.remove(gaConfigObject.softHiddenClass);
        observer.unobserve(entry.target);
      }
    });
  }

  scrollToBottomBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector("footer")?.scrollIntoViewIfNeeded();
  });
})();

window.gaUpdateCartCount = (count = 0) => {
  const cartCountElems = document.querySelectorAll(".js-cart-count");
  cartCountElems.forEach(
    (cartCountElem) => (cartCountElem.textContent = `${count}`)
  );
};

function updateCSSVariable(key, value) {
  document.documentElement.style.setProperty(key, value);
}

function isMobile() {
  return gaConfigObject.mobileWidth >= (window.innerWidth || screen.width);
}
